export default __webpack_public_path__ + "static/sessun_logo-c87ec856f177e2659ca76410daab8817.png";